import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { ReportTypeView } from "./ReportTypeView";
import { ReportTypeViewStore } from "../../store/ReportTypeViewStore";
import { useStore } from "../../../../hooks";

export const ReportTypeViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/reportType/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new ReportTypeViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <ReportTypeView reportTypeViewStore={store} />
      </PageLayout>
    </div>
  );
});
